import { GridCellSelectionModel } from '@mui/x-data-grid-premium'
import { useCallback, useState } from 'react'

/**
 * Hook for managing table selection
 */
export const useTableSelection = () => {
  const [cellSelectionModel, setCellSelectionModel] = useState<GridCellSelectionModel>({})

  const handleCellSelectionModelChange = useCallback((newModel: GridCellSelectionModel) => {
    setCellSelectionModel(newModel)
  }, [])

  const deselectAllCells = useCallback(() => {
    setCellSelectionModel({})
  }, [])

  return {
    cellSelectionModel,
    setCellSelectionModel,
    handleCellSelectionModelChange,
    deselectAllCells,
  }
}
